import type { GetAssessmentByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAssessmentByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAssessmentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetAssessmentByIdArgs = {
  Id: string;
};

export const useLazyGetAssessmentById = createLazyQueryHook<
  UseLazyGetAssessmentByIdArgs,
  GetAssessmentByIdResponseRow[],
  GetAssessmentByIdQuery
>({
  trpcQuery: (client, { Id }) =>
    client.frontend.assessment.getById.query({ id: Id }),
  mapTrpcDataToGraphQL: (data) => ({ assessment: data }),
  graphqlDocument: GetAssessmentByIdDocument,
  graphqlVariables: ({ Id }) => ({ Id }),
});
